module.exports = {"411471001":"中州街道","411471100":"张阁镇","411471101":"贾寨镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411471.json
// module id = 1783
// module chunks = 0